export const LOAD_ORDER = 'LOAD_ORDER';
export const SET_NEEDED_DATA = 'SET_NEEDED_DATA';
export const RESET_ORDERS_INFO = 'RESET_ORDERS_INFO';
export const CLONE_ORDER_ITEM = 'CLONE_ORDER_ITEM';
export const DELETE_ORDER_ITEM = 'DELETE_ORDER_ITEM';
export const REPRINT_ORDER_ITEM = 'REPRINT_ORDER_ITEM';
export const CANCEL_ORDER = 'CANCEL_ORDER';
export const CLONE_ORDER = 'CLONE_ORDER';
export const SET_CHECKED_ORDER_ITEMS = 'SET_CHECKED_ORDER_ITEMS';
export const SET_COMMENT_ORDER_ITEMS = 'SET_COMMENT_ORDER_ITEMS';
export const ADD_LINK_ORDER_ITEMS = 'ADD_LINK_ORDER_ITEMS';
export const ADD_DOCUMENT_ORDER_ITEMS = 'ADD_DOCUMENT_ORDER_ITEMS';
export const DELETE_DOCUMENT_ORDER_ITEMS = 'DELETE_DOCUMENT_ORDER_ITEMS';
export const DELETE_LINK_ORDER_ITEMS = 'DELETE_LINK_ORDER_ITEMS';
export const ADD_NEW_ORDER = 'ADD_NEW_ORDER';
export const EDIT_ORDER = 'EDIT_ORDER';
export const ADD_NEW_ORDER_ITEM = 'ADD_NEW_ORDER_ITEM';
export const EDIT_ORDER_ITEM = 'EDIT_ORDER_ITEM';
export const ADD_ADDITIONAL_ITEM = 'ADD_ADDITIONAL_ITEM';
export const DELETE_ADDITIONAL_ITEM = 'DELETE_ADDITIONAL_ITEM';
export const ADD_NEW_FAVORIS_ORDER = 'ADD_NEW_FAVORIS_ORDER';
export const DELETE_FAVORIS_ORDER = 'DELETE_FAVORIS_ORDER';
export const LOAD_BILLING_ACCOUNT = 'LOAD_BILLING_ACCOUNT';
export const ADD_PAYMENT_ORDER = 'ADD_PAYMENT_ORDER';
export const DELETE_PAYMENT_ORDER = 'DELETE_PAYMENT_ORDER';
export const LOAD_PAYMENT_TYPES = 'LOAD_PAYMENT_TYPES';
export const PAYMENT_ORDER_POPUP_VISIBILITY = 'PAYMENT_ORDER_POPUP_VISIBILITY';
export const ADD_PAYMENT_REQUEST_ORDER = 'ADD_PAYMENT_REQUEST_ORDER';
export const PAYMENT_REQUEST_ORDER_POPUP_VISIBILITY = 'PAYMENT_REQUEST_ORDER_POPUP_VISIBILITY';
export const LOAD_ORDER_INVOICES = 'LOAD_ORDER_INVOICES';
export const DELETE_PRINTING_FILE = 'DELETE_PRINTING_FILE';
export const CHANGE_ORDER_ITEM_STATUS = 'CHANGE_ORDER_ITEM_STATUS';
export const SHOW_PRINTING_OFFICE_POPUP = 'SHOW_PRINTING_OFFICE_POPUP';
export const HIDE_PRINTING_OFFICE_POPUP = 'HIDE_PRINTING_OFFICE_POPUP';
export const CHANGE_PRINTING_OFFICE = 'CHANGE_PRINTING_OFFICE';
export const SET_EXPECTED_SHIPPING_DATE = 'SET_EXPECTED_SHIPPING_DATE';
export const EDIT_SHIPPING_TYPE_ORDER = 'EDIT_SHIPPING_TYPE_ORDER';
export const ORDER_TO_RECEIVED = 'ORDER_TO_RECEIVED';
export const LOAD_ORDER_PRINT_VERSIONS = 'LOAD_ORDER_PRINT_VERSIONS';
export const EDIT_SHIPPING_ADDRESS = 'EDIT_SHIPPING_ADDRESS';
export const CHANGE_BILLING_ACCOUNT = 'CHANGE_BILLING_ACCOUNT';
export const TOGGLE_BILLING_ACCOUNT_POPUP = 'TOGGLE_BILLING_ACCOUNT_POPUP';
export const SET_PRINT_VERSION_DATA = 'SET_PRINT_VERSION_DATA';
export const ADD_PRINTING_FILE = 'ADD_PRINTING_FILE';
export const SET_VIEW_DESIGN_VARIANTS_POPUP = 'SET_VIEW_DESIGN_VARIANTS_POPUP';
export const ADD_DISCOUNT_INTO_ORDER = 'ADD_DISCOUNT_INTO_ORDER';
export const CHANGE_ORDER_STATUS_TO_WAITING_FOR_PAYMENT = 'CHANGE_ORDER_STATUS_TO_WAITING_FOR_PAYMENT';
export const DOWNLOAD_ORDER_PDF = 'DOWNLOAD_ORDER_PDF';
export const DOWNLOAD_ORDER_ITEM_PDF = 'DOWNLOAD_ORDER_ITEM_PDF';
export const LOAD_ORDERS = 'LOAD_ORDERS';
export const SET_ORDERS_PAGINATION = 'SET_ORDERS_PAGINATION';
export const SET_ORDERS_SORT = 'SET_ORDERS_SORT';
export const RESET_ORDERS_FILTERS = 'RESET_ORDERS_FILTERS';
export const SET_ORDERS_FILTER = 'SET_ORDERS_FILTER';
